import { jsx } from "react/jsx-runtime";
import { getDefaultProps, simulatorClass, simulatorRootClass, onClickHandler, disableEventHandler } from "@prismicio/simulator/kit";
const SliceSimulatorWrapper = ({ className, children, zIndex, background, message, hasSlices }) => {
  const defaultProps = getDefaultProps();
  return jsx("div", { className: [simulatorClass, className].filter(Boolean).join(" "), style: {
    zIndex: typeof zIndex === "undefined" ? defaultProps.zIndex : zIndex ?? void 0,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    overflow: "auto",
    background: typeof background === "undefined" ? defaultProps.background : background ?? void 0
  }, children: message ? jsx("article", { dangerouslySetInnerHTML: { __html: message } }) : hasSlices ? jsx("div", { id: "root", className: simulatorRootClass, onClickCapture: onClickHandler, onSubmitCapture: disableEventHandler, children }) : null });
};
export {
  SliceSimulatorWrapper
};
//# sourceMappingURL=SliceSimulatorWrapper.js.map
